var map = {
	"./answer.svg": "af7f",
	"./avatar_vip.svg": "4287",
	"./baseInfo.svg": "c65b",
	"./cb-dc.svg": "25e0",
	"./cb-dz-no-color.svg": "bf14",
	"./cb-dz.svg": "b4c7",
	"./cb-fx.svg": "a1bb",
	"./cb-qxc.svg": "fb1e",
	"./cb-qxdz.svg": "d2e1",
	"./changePwd.svg": "b1d5",
	"./close.svg": "7710",
	"./collect-btn.svg": "95ae",
	"./collect-btn1.svg": "2c45",
	"./collect-no-color.svg": "63ca",
	"./collect.svg": "a554",
	"./collectbar.svg": "dfe2",
	"./collected.svg": "fc76",
	"./delete.svg": "59a1",
	"./dropdown.svg": "5586",
	"./edit.svg": "aa46",
	"./email.svg": "cbb7",
	"./extendInfo.svg": "aff6",
	"./focus.svg": "0f51",
	"./follow.svg": "a8c4",
	"./forward-btn.svg": "9988",
	"./forward-btn1.svg": "2e4d",
	"./like-btn.svg": "ecc5",
	"./like-btn1.svg": "1d2a",
	"./like-light.svg": "1071",
	"./like.svg": "c814",
	"./link.svg": "18f0",
	"./message.svg": "47ff",
	"./new.svg": "ac90",
	"./noticeIcon1.svg": "8c47",
	"./noticeIcon2.svg": "947d",
	"./noticeIcon3.svg": "b8cc",
	"./noticeIcon4.svg": "3ec6",
	"./qq.svg": "1430",
	"./recommend0.svg": "7b33",
	"./recommend1.svg": "8003",
	"./recommend2.svg": "a685",
	"./search.svg": "8e8d",
	"./send.svg": "94d0",
	"./sends.svg": "e7c1",
	"./success.svg": "a8cf",
	"./tif.svg": "1f72",
	"./uncollectbar.svg": "3f65",
	"./upload.svg": "9d82",
	"./vip.svg": "1296",
	"./wechat.svg": "80da",
	"./wx.svg": "ddee"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "51ff";